/*
 * Tracking Event Editor - Event Trackers Editor Dialog
 *
 */
import angular from "angular";

import kendo from "@progress/kendo-ui";
import "kendo.timezones";
import ngAnimateModule from "angular-animate";
import ngSanitizeModule from "angular-sanitize";
import uiBootstrapModule from "angular-ui-bootstrap";
import kendoDirectives from "../../shims/kendoDirectives";

import Assert from "tbAssert";

import TrackerDataServiceModule from "../../services/TrackerDataService";

const eventAttendeesDialogRootElement = "eventTrackersModalContentRoot";

const mScopeSvc = new WeakMap();
const mModalInstance = new WeakMap();
const mTrackerDataSvc = new WeakMap();

const mTrackersToAdd = new WeakMap();
const mSelectedTrackers = new WeakMap();
const mActiveTrackerDataSource = new WeakMap();

const mTrackerSelectorOptions = new WeakMap();
const mTrackerListChanged = new WeakMap();

const EventTrackersEditorDialogCancelledStatusMessage = "TRACKER_EDIT_USER_CANCEL";

class EventTrackersEditorDialogController {
    constructor($scope,
                $uibModalInstance,
                TrackerData,
                eventTrackers)
    {
        Assert.StrictAssert($scope != null, "Assertion Failure: Missing Scope Service Dependency");
        Assert.StrictAssert($uibModalInstance != null, "Assertion Failure: Missing UI Modal Instance Dependency");
        Assert.StrictAssert(TrackerData != null, "Assertion Failure: Missing Tracker Data Service Dependency");
        Assert.StrictAssert(eventTrackers != null, "Assertion Failure: Event Trackers Input Dependency");

        mScopeSvc.set(this, $scope);
        mModalInstance.set(this, $uibModalInstance);
        mTrackerDataSvc.set(this, TrackerData);
        mSelectedTrackers.set(this, eventTrackers);

        mTrackerListChanged.set(this, false);

        mTrackersToAdd.set(this, []);

        let activeTrackerDataSourceParams = {
            serverFiltering: true,
            transport: {
                read: (options) => {
                    let lnQuery = null;

                    if (options.data["filter"] != null) {
                        if (options.data.filter.filters.length > 0) {
                            lnQuery = options.data.filter.filters[0].value;
                        }
                    }

                    if (lnQuery == null) {
                        options.success([]);
                        return;
                    }

                    mTrackerDataSvc.get(this)
                        .search(lnQuery, true)
                        .then(
                            (trackerSearchResult) => {
                                options.success(trackerSearchResult.trackerData);
                            },
                            (errorResponse) => {
                                options.error(errorResponse);
                            }
                        );
                }
            }
        };

        mActiveTrackerDataSource.set(this, new kendo.data.DataSource(activeTrackerDataSourceParams));

        mTrackerSelectorOptions.set(this, {
            dataSource: mActiveTrackerDataSource.get(this),
            filter: "contains",
            delay: 500,
            dataTextField: "displayName",
            dataValueField: "trackerId",
            minLength: 2
        });

        mScopeSvc.get(this).$on("$destroy", () => {
            let trackersEditorRootElement =
                angular.element(`#${eventAttendeesDialogRootElement}`);

            kendo.destroy(trackersEditorRootElement);
        });
    }

    get trackersToAdd() {
        return mTrackersToAdd.get(this);
    }

    set trackersToAdd(updatedVal) {
        mTrackersToAdd.set(this, updatedVal);
    }

    get selectedTrackers() {
        return mSelectedTrackers.get(this);
    }

    get trackerSelectorOptions() {
        return mTrackerSelectorOptions.get(this);
    }

    get trackerListChanged() {
        return mTrackerListChanged.get(this);
    }

    addSelectedTrackers() {
        if (this.trackersToAdd.length > 0)
        {
            Array.prototype.push.apply(this.selectedTrackers, this.trackersToAdd);
            mTrackerListChanged.set(this, true);
            this.trackersToAdd.length = 0;
        }
    }

    removeSelectedTracker(trackerIdx) {
        this.selectedTrackers.splice(trackerIdx, 1);
        mTrackerListChanged.set(this, true);
    }

    updateAssignedTrackers() {
        let chosenEventTrackers = mSelectedTrackers.get(this);
        mModalInstance.get(this).close(chosenEventTrackers);
    }

    cancelDialog() {
        mModalInstance.get(this).dismiss(EventTrackersEditorDialogCancelledStatusMessage);
    }
}

EventTrackersEditorDialogController.$inject = [
    "$scope",
    "$uibModalInstance",
    "TrackerData",
    "eventTrackers"
];

EventTrackersEditorDialogController.dependencies = [
    ngAnimateModule,
    ngSanitizeModule,
    uiBootstrapModule,
    kendoDirectives,
    TrackerDataServiceModule
];

EventTrackersEditorDialogController.template = require("./EventTrackersEditorDialog.tpl.html");

EventTrackersEditorDialogController.controllerAs = "eventTrackersEditor";

EventTrackersEditorDialogController.UserCancelledStatusMessage = EventTrackersEditorDialogCancelledStatusMessage;

export default EventTrackersEditorDialogController;



//////////////////
// WEBPACK FOOTER
// ./src/views/tracking-event-editor/EventTrackersEditorDialogController.js
// module id = vxkk
// module chunks = 1